var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-scroll-view",
    { attrs: { tag: "w-card-content" } },
    [
      _c(
        "w-row",
        [
          _c(
            "w-col",
            { attrs: { xs: "12" } },
            [
              _c("w-checkbox", {
                attrs: { label: _vm.$ct("send-via-peppol") },
                model: {
                  value: _vm.state.doc.SendViaPeppol,
                  callback: function ($$v) {
                    _vm.$set(_vm.state.doc, "SendViaPeppol", $$v)
                  },
                  expression: "state.doc.SendViaPeppol",
                },
              }),
            ],
            1
          ),
          _c(
            "w-col",
            { attrs: { xs: "12" } },
            [
              _c(
                "w-row",
                { attrs: { "no-margin": "" } },
                [
                  _c("w-select", {
                    style: { flexGrow: 1 },
                    attrs: {
                      items: _vm.sendMailEnabledItems,
                      label: _vm.$ct("is-send-mail-enabled"),
                      fancy: "",
                    },
                    model: {
                      value: _vm.state.doc.SendMailEnabled,
                      callback: function ($$v) {
                        _vm.$set(_vm.state.doc, "SendMailEnabled", $$v)
                      },
                      expression: "state.doc.SendMailEnabled",
                    },
                  }),
                  _c(
                    "w-dropdown",
                    {
                      directives: [
                        {
                          name: "tooltip",
                          rawName: "v-tooltip",
                          value: _vm.$ct("select-template"),
                          expression: "$ct('select-template')",
                        },
                      ],
                      attrs: {
                        flat: "",
                        items: _vm.templateItems,
                        right: "",
                        disabled: !_vm.sendMailEnabled,
                      },
                      on: {
                        click: function ($event) {
                          return _vm.loadTemplate($event)
                        },
                      },
                    },
                    [_c("w-fa", { attrs: { icon: "file" } })],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "w-row",
        [
          _c(
            "w-col",
            { attrs: { xs: "12", md: "6" } },
            [
              _c("w-input", {
                attrs: {
                  disabled: !_vm.sendMailEnabled,
                  fancy: "",
                  label: _vm.$ct("mail-to"),
                },
                model: {
                  value: _vm.state.doc.MailTo,
                  callback: function ($$v) {
                    _vm.$set(_vm.state.doc, "MailTo", $$v)
                  },
                  expression: "state.doc.MailTo",
                },
              }),
            ],
            1
          ),
          _c(
            "w-col",
            { attrs: { xs: "12", md: "6" } },
            [
              _c("w-input", {
                attrs: {
                  disabled: !_vm.sendMailEnabled,
                  fancy: "",
                  label: _vm.$ct("mail-from"),
                },
                model: {
                  value: _vm.state.doc.MailFrom,
                  callback: function ($$v) {
                    _vm.$set(_vm.state.doc, "MailFrom", $$v)
                  },
                  expression: "state.doc.MailFrom",
                },
              }),
            ],
            1
          ),
          _c(
            "w-col",
            { attrs: { xs: "12", md: "6" } },
            [
              _c("w-input", {
                attrs: {
                  disabled: !_vm.sendMailEnabled,
                  fancy: "",
                  label: _vm.$ct("mail-cc"),
                },
                model: {
                  value: _vm.state.doc.MailCC,
                  callback: function ($$v) {
                    _vm.$set(_vm.state.doc, "MailCC", $$v)
                  },
                  expression: "state.doc.MailCC",
                },
              }),
            ],
            1
          ),
          _c(
            "w-col",
            { attrs: { xs: "12", md: "6" } },
            [
              _c("w-input", {
                attrs: {
                  disabled: !_vm.sendMailEnabled,
                  fancy: "",
                  label: _vm.$ct("mail-bcc"),
                },
                model: {
                  value: _vm.state.doc.MailBCC,
                  callback: function ($$v) {
                    _vm.$set(_vm.state.doc, "MailBCC", $$v)
                  },
                  expression: "state.doc.MailBCC",
                },
              }),
            ],
            1
          ),
          _c(
            "w-col",
            { attrs: { xs: "12", md: "6" } },
            [
              _c("w-input", {
                attrs: {
                  disabled: !_vm.sendMailEnabled,
                  fancy: "",
                  label: _vm.$ct("subject"),
                },
                model: {
                  value: _vm.state.doc.MailSubject,
                  callback: function ($$v) {
                    _vm.$set(_vm.state.doc, "MailSubject", $$v)
                  },
                  expression: "state.doc.MailSubject",
                },
              }),
            ],
            1
          ),
          _c(
            "w-col",
            { attrs: { xs: "12", md: "6" } },
            [
              _c("app-prop-select", {
                attrs: {
                  disabled: !_vm.sendMailEnabled,
                  text: _vm.contentAsText,
                  "cursor-position": _vm.cursorPosition,
                  data: _vm.props,
                },
                on: {
                  add: function ($event) {
                    return _vm.addProp($event)
                  },
                },
              }),
            ],
            1
          ),
          _c(
            "w-col",
            { attrs: { xs: "12" } },
            [
              _c("app-mail-template-editor", {
                ref: "editor",
                attrs: { "is-html": "", disabled: !_vm.sendMailEnabled },
                on: {
                  "cursor-position-change": function ($event) {
                    _vm.cursorPosition = $event
                  },
                  "text-value": function ($event) {
                    _vm.contentAsText = $event
                  },
                },
                model: {
                  value: _vm.state.doc.MailContentTemplate,
                  callback: function ($$v) {
                    _vm.$set(_vm.state.doc, "MailContentTemplate", $$v)
                  },
                  expression: "state.doc.MailContentTemplate",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }